import styled, { css } from 'styled-components';
import { squareBulletPoints } from '../styled/lists';

/**
 * The overflow-wrap is set here to avoid URLs and other
 * long strings breaking out of the container on mobile
 * layouts.
 */
export const Paragraph = styled.p`
  // These two are equivalent, but despite caniuse indicating
  // that Safari uses overflow-wrap, it doesn't seem to be
  // applied when tested
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const Wrapper = styled.div`
  ${({ $backgroundColor, theme }) =>
    $backgroundColor === 'grey' &&
    css`
      background-color: ${theme.palette.lightBackground};
    `}

  ${({ $padding, theme }) =>
    $padding &&
    css`
      padding: ${theme.spacing.standard};
      margin-bottom: ${theme.spacing.standard};
    `}

    ${({ $backgroundColor, theme }) =>
    $backgroundColor === 'grey' &&
    css`
      padding-top: ${theme.spacing.standard};
      padding-bottom: ${theme.spacing.standard};
    `}

  ul {
    ${squareBulletPoints};
  }

  ol li::before {
    min-width: 10px;
  }

  h1,
  h2,
  h3,
  h4 {
    &:first-child {
      margin-top: 0;
    }
  }
`;
